import { render, staticRenderFns } from "./GroupNeedsCosigner.vue?vue&type=template&id=84b97904&"
import script from "./GroupNeedsCosigner.vue?vue&type=script&lang=js&"
export * from "./GroupNeedsCosigner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports